<template>
  <div class="practice-stats-main-info statsmf">
    <div
      v-for="(tb, idx) in items"
      :key="tb.name + idx"
      class="statsmf_box"
    >
      <div class="statsmf_box_title">
        {{ tb.name }}
      </div>
      <div class="statsmf_box_value gw_loading_text">{{ tb.value }} {{ tb.unit || '' }}</div>
    </div>
  </div>
</template>

<script>
import format_mix from '@/mixins/format_mix'
import float_mix from '@/mixins/float_mix'

export default {
  name: 'PracticeStatsMainInfo',
  mixins: [format_mix, float_mix],
  props: {
    items: Array,
  },
  data() {
    return {}
  },
}
</script>

<style lang="scss" scoped>
.statsmf {
  // --gap: 2rem;

  // --display: flex;
  --flex-wrap: wrap;

  --display: grid;
  --gap: 2rem;
  --grid-template-columns: repeat(4, 1fr);
  // --grid-template-rows: repeat(1, 1fr);
  // --grid-auto-flow: column;

  --clr-title: var(--clr-grey-2);
  --clr-value: var(--clr-white-0);
  --size-title: 1rem;
  --size-value: 1.25rem;
  --weight-title: 500;
  --weight-value: 600;
  --transform-title: uppercase;
  --transform-value: uppercase;
  --item-margin: 0;

  display: var(--display);
  grid-template-columns: var(--grid-template-columns);
  grid-template-rows: var(--grid-template-rows);
  grid-auto-flow: var(--grid-auto-flow);
  gap: var(--gap);
  flex-wrap: var(--flex-wrap);

  &_box {
    display: flex;
    flex-direction: column;
    margin: var(--item-margin);
    &_title {
      font-size: var(--size-title);
      color: var(--clr-title);
      font-weight: var(--weight-title);
      text-transform: var(--transform-title);
    }
    &_value {
      color: var(--clr-value);
      font-size: var(--size-value);
      font-weight: var(--weight-value);
      text-transform: var(--transform-value);
    }
  }
}
</style>
